(function (angular) {
  "use strict";

  var REGION_MAP = {
    "NORTHERN REGION": "North",
    "SOUTHERN REGION": "South",
    "EASTERN REGION": "East",
    "WESTERN REGION": "West",
    "CENTRAL REGION": "Central",
    "ALL REGIONS": "ALL REGIONS"
  };

  angular.module("Toyota.Directives").directive("tyPricingOfferCta", [
    "Dealer",
    "PricingPageAnalyticsService",
    function (Dealer, PricingPageAnalyticsService) {
      var controller = [
        "$scope",
        "$element",
        "$attrs",
        function ($scope, $element, $attrs) {
          var ctaMap = null;
          var currentGradeId = null;
          var currentVariantId = null;

          function resolveActiveCta(selectedGradeCode, selectedVariantCode) {
            if (!ctaMap) return null;

            // 1. Model Level check (Highest Priority)
            if (ctaMap.modelCta && ctaMap.modelCta.isEnabled) {
              return ctaMap.modelCta;
            }

            // 2. Grade Level check for currently selected grade
            if (selectedGradeCode && ctaMap.gradeCtas && ctaMap.gradeCtas[selectedGradeCode]) {
              return ctaMap.gradeCtas[selectedGradeCode];
            }

            // 3. Variant Level check for currently selected variant
            if (selectedVariantCode && ctaMap.variantCtas && ctaMap.variantCtas[selectedVariantCode]) {
              return ctaMap.variantCtas[selectedVariantCode];
            }

            return null;
          }

          function updateDomElements(cta) {
            var $link = $element.find(".ty-pricing-offer-cta__link");
            $element.find(".ty-pricing-offer-cta__label").text(cta.label);
            $element.find(".ty-pricing-offer-cta__link-text").text(cta.text);
            $link.attr("href", cta.link);

            $link.off("click.offerCtaAnalytics").on("click.offerCtaAnalytics", function () {
              if (cta) {
                var label = [cta.label, cta.text].filter(Boolean).join(" - ");
                PricingPageAnalyticsService.triggerAnalytics("gaClick", {
                  eventCategory: "pricing",
                  eventAction: "link",
                  eventLabel: label
                });
              }
            });
          }

          function evaluateAndApplyVisibility() {
            if (!$attrs.offerCtaMap) {
              hideCtaElement();
              return;
            }

            ctaMap = angular.fromJson($attrs.offerCtaMap);

            var activeCta = resolveActiveCta(currentGradeId, currentVariantId);

            if (!activeCta || !activeCta.isEnabled) {
              hideCtaElement();
              return;
            }

            // Hide offer CTA if no dealer has been selected / saved
            var dealer = Dealer.getSaved();

            if (!dealer || !dealer.branchCode) {
              hideCtaElement();
              return;
            }

            updateDomElements(activeCta);

            // If dealer is selected and CTA is national, display it
            if (activeCta.isNational) {
              showCtaElement();
              return;
            }

            // Otherwise, verify dealer's region matches the CTA regions
            if (dealerRegionMatchesCta(dealer, activeCta)) {
              showCtaElement();
            } else {
              hideCtaElement();
            }
          }

          function dealerRegionMatchesCta(dealer, activeCta) {
            if (!dealer.region || !activeCta.regions) return false;
            var dealerRegion = dealer.region.trim().toLowerCase();

            return activeCta.regions.some(function (sitecoreRegion) {
              var mapped = REGION_MAP[sitecoreRegion.trim().toUpperCase()];
              return mapped && mapped.trim().toLowerCase() === dealerRegion;
            });
          }

          function showCtaElement() {
            $element.removeClass("is-hidden");
          }

          function hideCtaElement() {
            $element.addClass("is-hidden");
          }

          // Listen to Grade changes broadcast by tyPricingPage
          $scope.$on("grade-changed", function (event, gradeId) {
            currentGradeId = gradeId;
            currentVariantId = null; // Clear variant on grade switch until variant-changed fires
            evaluateAndApplyVisibility();
          });
          function handleVariantChange(data) {
            if (data) {
              if (data.grade && data.grade.id) {
                currentGradeId = data.grade.id;
              }
              if (data.variantIds && data.variantIds.length > 0) {
                currentVariantId = data.variantIds[0].toLowerCase();
              }
            }

            evaluateAndApplyVisibility();
          }

          // Listen to Variant changes broadcast by tyPricingPage
          $scope.$on("variant-changed", function (event, data) {
            handleVariantChange(data);
          });

          // Listen to Option Pack changes broadcast by tyPricingOptionPackSelector
          $scope.$on("option-pack-changed", function (event, data) {
            handleVariantChange(data);
          });

          // Listen to dealer changes
          $scope.$on("dealer-saved-did-change", evaluateAndApplyVisibility);

          // Unbind event listeners on directive destruction
          $scope.$on("$destroy", function () {
            $element.find(".ty-pricing-offer-cta__link").off(".offerCtaAnalytics");
          });

          this.$onInit = function () {
            evaluateAndApplyVisibility();
          };
        }
      ];

      return {
        controller: controller,
        restrict: "A",
        scope: false
      };
    }
  ]);
})(window.angular);